import * as React from 'react'

import { Box, Href, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import { ContractFlowType } from 'modules/contracts/components/FlowPage'
import Hint from 'modules/contracts/components/FlowPage/FormWrapper/Hint'

interface WorkHoursHintProps {
  step: number
  type: ContractFlowType
  isContractHoursSet: boolean
  isWorkingFrequencySet: boolean
}

const WorkHoursHint = ({
  step,
  type,
  isContractHoursSet,
  isWorkingFrequencySet,
}: WorkHoursHintProps) => {
  const trackLink = () => {
    track(trackingEvents.employee.contracts.goToContractHoursLink, {
      step: step,
      type: type,
    })
  }

  return (
    <Hint color="viridian100" visible={!isContractHoursSet || !isWorkingFrequencySet}>
      <Href
        onClick={() => trackLink()}
        href={helpCenterUrl('about_contracts_hours')}
        target="_blank"
      >
        <Text.Normal color="grey1000" weight="normal" size="100">
          {i18n.t('contract_versions.flows.update.steps.work_hours.hints.hours')}
          <Text.Normal size="100" weight="normal" color="grey1000" underlined>
            <Box paddingLeft="s2">{i18n.t('contract_versions.flows.update.hints.know_more')}</Box>
          </Text.Normal>
        </Text.Normal>
      </Href>
    </Hint>
  )
}

export default observer(WorkHoursHint)
